import instance from '@/api/config'
import mergeApi from '@/api/mergeApi'

const service = {
  ...mergeApi
}

const api = {}

for (const i in service) {
  const config = service[i]
  api[i] = function(formData, apiConfig) {
    switch (config.method.toLowerCase()) {
      case 'get':
        return instance({
          ...config,
          ...apiConfig,
          params: formData
        })
      default:
        return instance({
          ...config,
          ...apiConfig,
          data: formData
        })
    }
  }
}

export default api
